import { EllipsisVertical, X } from "lucide-react";
import React from "react";
import Dropdown from "../../DropdownMenu";
import Flex from "../../Flex";
import IconButton from "../../IconButton";
import DatePicker from "../DatePicker";
import PRESET_OPTIONS from "./constants";
import useDateRangePicker from "./hooks/useDateRangePicker";
import { BaseDateRangePicker, BaseDateRangePickerLabel, DateContainer, DatePickerContainer, ExtrasContainer } from "./styled";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var DateRangePicker = /*#__PURE__*/React.forwardRef(function (_ref, forwardedRef) {
  var value = _ref.value,
    _ref$toLabel = _ref.toLabel,
    toLabel = _ref$toLabel === void 0 ? "To" : _ref$toLabel,
    _ref$fromLabel = _ref.fromLabel,
    fromLabel = _ref$fromLabel === void 0 ? "From" : _ref$fromLabel,
    name = _ref.name,
    id = _ref.id,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {
      return null;
    } : _ref$onChange,
    minYear = _ref.minYear,
    maxYear = _ref.maxYear,
    _ref$hasError = _ref.hasError,
    hasError = _ref$hasError === void 0 ? false : _ref$hasError,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$showPresets = _ref.showPresets,
    showPresets = _ref$showPresets === void 0 ? true : _ref$showPresets,
    defaultValueFromPreset = _ref.defaultValueFromPreset;
  var _useDateRangePicker = useDateRangePicker(value, onChange, defaultValueFromPreset),
    selectedValue = _useDateRangePicker.selectedValue,
    inputRef = _useDateRangePicker.inputRef,
    calendarValue = _useDateRangePicker.calendarValue,
    handleClearButtonClick = _useDateRangePicker.handleClearButtonClick,
    handleNewStartDate = _useDateRangePicker.handleNewStartDate,
    handleNewEndDate = _useDateRangePicker.handleNewEndDate,
    handlePresetSelect = _useDateRangePicker.handlePresetSelect;
  var itemsArray = PRESET_OPTIONS.map(function (option) {
    return {
      label: option.label,
      key: option.key,
      onClick: function onClick() {
        handlePresetSelect(option);
      }
    };
  });
  return /*#__PURE__*/_jsx(BaseDateRangePicker, {
    ref: forwardedRef,
    children: /*#__PURE__*/_jsxs(DatePickerContainer, {
      children: [/*#__PURE__*/_jsxs(Flex, {
        direction: "row",
        wrap: "wrap",
        spacing: "none",
        children: [/*#__PURE__*/_jsxs(DateContainer, {
          children: [/*#__PURE__*/_jsx(BaseDateRangePickerLabel, {
            id: "".concat(id, "_start_date"),
            children: fromLabel
          }), /*#__PURE__*/_jsx(DatePicker, {
            disabled: disabled,
            hasError: hasError,
            showFirstDateInRangeOnOpen: true,
            minYear: minYear && minYear,
            maxYear: maxYear && maxYear,
            onChange: handleNewStartDate,
            value: selectedValue.startDate,
            calendarValue: calendarValue.length === 1 ? calendarValue[0] : calendarValue,
            id: "".concat(id, "_start_date"),
            onSelectedDateChange: function onSelectedDateChange() {
              return inputRef.current.children[0].children[0].children[0].focus();
            },
            name: "".concat(name, "_start_date")
          })]
        }), /*#__PURE__*/_jsxs(DateContainer, {
          children: [/*#__PURE__*/_jsx(BaseDateRangePickerLabel, {
            id: "".concat(id, "_end_date"),
            children: toLabel
          }), /*#__PURE__*/_jsx(DatePicker, {
            ref: inputRef,
            disabled: disabled,
            hasError: hasError,
            minYear: minYear && minYear,
            maxYear: maxYear && maxYear,
            value: selectedValue.endDate,
            onChange: handleNewEndDate,
            calendarValue: calendarValue,
            id: "".concat(id, "_end_date"),
            name: "".concat(name, "_end_date")
          })]
        })]
      }), /*#__PURE__*/_jsxs(ExtrasContainer, {
        children: [/*#__PURE__*/_jsx(IconButton, {
          tooltipContent: "Clear",
          disabled: disabled,
          onClick: function onClick() {
            return handleClearButtonClick();
          },
          icon: /*#__PURE__*/_jsx(X, {})
        }), showPresets && /*#__PURE__*/_jsx(Dropdown, {
          disabled: disabled,
          trigger: {
            type: "iconButton",
            props: {
              icon: /*#__PURE__*/_jsx(EllipsisVertical, {}),
              tooltipContent: "Preset Ranges"
            }
          },
          items: itemsArray,
          preferredAlignment: "center"
        })]
      })]
    })
  });
});
DateRangePicker.displayName = "DateRangePicker";
export default DateRangePicker;